import request from '@/util/request'

export async function registerAssayPhoto({
    companyId,
    lotAssayId,
    contentType,
    caption,
    customerVisible,
    sortOrder,
}) {
    const {result} = await request.post(`/refinery/lot-assays/${companyId}/${lotAssayId}/photos`, {
        contentType,
        caption,
        customerVisible,
        sortOrder,
    })
    return {photo: result.photo, putUrl: result.putUrl}
}

export async function confirmAssayPhoto({companyId, lotAssayId, photoId}) {
    const {result} = await request.post(
        `/refinery/lot-assays/${companyId}/${lotAssayId}/photos/${photoId}/confirm`,
        {}
    )
    return {photo: result.photo}
}

export async function deleteAssayPhoto({companyId, lotAssayId, photoId}) {
    const {result} = await request.delete(
        `/refinery/lot-assays/${companyId}/${lotAssayId}/photos/${photoId}`
    )
    return {photo: result.photo}
}

export async function setAssayPhotoVisibility({companyId, lotAssayId, photoId, customerVisible}) {
    const {result} = await request.post(
        `/refinery/lot-assays/${companyId}/${lotAssayId}/photos/${photoId}/visibility`,
        {customerVisible}
    )
    return {photo: result.photo}
}